import { createContext, useContext } from "react";

import { type DataTableSettingsContextType } from "./types";

export const DataTableSettingsContext =
  createContext<DataTableSettingsContextType | null>(null);

export function useDataTableSettingsContext() {
  const context = useContext(DataTableSettingsContext);

  if (!context) {
    throw new Error(
      "useDataTableSettingsContext must be used within a DataTableSettingsProvider",
    );
  }

  return context;
}
